import { createSelector } from "reselect";
import { AppState } from "../rootReducer";

// Notifications  

const getNotificationList = (state: AppState) => state.notifications.notifications;
export const getNotificationsSelector = createSelector(getNotificationList, (notifications) => notifications);

